(function () {
    angular.module('st')
        .controller('lrHamburgerCtrl', [
            '$rootScope', '$scope',
            function ($rootScope, $scope) {
                var ctrl = this;
                ctrl.hamburgerClasses = {
                    opened: false
                };

                $rootScope.$on('topNavOpen', function () {
                    ctrl.hamburgerClasses.opened = true;
                });

                $rootScope.$on('topNavClose', function () {
                    ctrl.hamburgerClasses.opened = false;
                });

                ctrl.toggle = function () {
                    $rootScope.$broadcast('topNavToggle');
                };
            }]);

})();